module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.f6e84ad.eot";